import _ from 'lodash';
import Backbone from 'backbone';

const RoleModel = Backbone.Model.extend({
    idAttribute: 'id',
    url: '/api/role',
    defaults: {
        name: '',
        count: 0,
    },
    initialize: function initialize() {
        this.idAttribute = 'id';
    },
    parse(data) {
        const model = data && (_.isArray(data.data) && data.data.length > 0) ? data.data[0] : data;
        if (model && model.response) {
            delete model.response;
        }
        return model;
    },

    getModelId() {
        return this.attributes.id;
    },

    getName() {
        return this.attributes.name;
    },

    setName(name) {
        this.set({name});
    },

    getCount() {
        return this.attributes.count;
    },

    setCount(count) {
        this.set({count});
    },

    getRoles() {
        return this.attributes.roles;
    },

    getGlobalRoleId() {
        return this.attributes.globalRoleId;
    },

    getContextRoleId() {
        return this.attributes.contextRoleId;
    },
});

export default RoleModel;
